import { COOKIE_KEYS } from 'constants/common'
import { TWPERMISSIONS } from 'dataSource/auth/types'
import { TreatmentFlags, treatmentFlagValues } from 'constants/treatments'
import useGetUserTreatment from 'hooks/treatments/useGetUserTreatment'
import Cookies from 'js-cookie'
import { ReadonlyURLSearchParams } from 'next/navigation'
import { NenaQueryParams } from '../types'

export const useNenaServerEndpoints = (): boolean =>
  useGetUserTreatment(TreatmentFlags.USE_NENA_SERVER_ENDPOINTS) ===
  treatmentFlagValues.ON

export const canAccessNena = (permissions: TWPERMISSIONS[]): boolean => {
  return [
    TWPERMISSIONS.SUPPORT,
    TWPERMISSIONS.CLINICAL_ADMIN,
    TWPERMISSIONS.CLINICIAN,
    TWPERMISSIONS.RESIDENTS,
    TWPERMISSIONS.SYNCHRONOUS_TEAM,
    TWPERMISSIONS.COE_STAFF,
    TWPERMISSIONS.MEDICAL_ASSISTANTS,
    TWPERMISSIONS.CLINOPS_MCD_AND_MAS,
  ].some((allowedPermission) => permissions.includes(allowedPermission))
}

export const setNenaTokenToCookies = (
  token: string,
  expires?: number
): void => {
  Cookies.set(COOKIE_KEYS.NENA_TOKEN, JSON.stringify(token), {
    ...(expires != null &&
      typeof expires === 'number' && { expires: new Date(expires) }),
    secure: true,
    path: '/',
  })
}

export const getNenaTokenFromCookies = (): string | null => {
  const value = Cookies.get(COOKIE_KEYS.NENA_TOKEN)

  if (!value) {
    return null
  }

  try {
    const parsed: unknown = JSON.parse(value)
    // A non-string cookie value would be sent on as the token, drawing a 498 and
    // invalidating the shared token cache. Treat it as absent so it refreshes.
    return typeof parsed === 'string' ? parsed : null
  } catch {
    return null
  }
}

export const clearNenaTokenFromCookies = (): void => {
  Cookies.remove(COOKIE_KEYS.NENA_TOKEN)
}

export const getGeometryFromSearchParams = (
  searchParams: ReadonlyURLSearchParams
): { lat: number; lng: number } | null => {
  const geometry = searchParams.get(NenaQueryParams.GEOMETRY)

  if (!geometry) {
    return null
  }

  const latLngArray = geometry.split(',')

  if (latLngArray.length !== 2) {
    return null
  }

  return {
    lat: parseFloat(latLngArray[0]),
    lng: parseFloat(latLngArray[1]),
  }
}
